<template>
    <div class="container col-12 mt-4">
        <form @submit.prevent="submitFiles" >
            <div class="dropbox">
                <b-form-file 
                    @change="onFileChange($event)" 
                    :placeholder="$t('Inserir anexos')"
                    multiple                    
                    ref="file-input"
                    class="mb-2"
                    v-model="selectFiles"
                    :state="Boolean(selectFiles)"
                    :file-name-formatter="formatNames"
                    id="formFilesAfericao"
                    ></b-form-file>
            </div>
            <button class="btn btn-success d-none"  type="submit" id="btnFormFiles">Enviar Anexos</button>
        </form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            files: [],
            selectFiles: null,
        }
    },
    methods: {
        formatNames(files) {
            return files.length === 1 ? files[0].name : `${files.length} arquivos selecionados`
        },
        onFileChange(event) {
            this.files = event.target.files
            this.$store.commit('borracharia/setFilesUpload', event.target.files )
        },
        submitFiles() {
            // const formData = new FormData();

            // for (let i = 0; i < this.files.length; i++) {
            //     formData.append('files[]', this.files[i]);
            // }

            // this.$store.dispatch(`borracharia/uploadFiles`, { data: formData, nrSeqOs: this.$route.params.id }).then(response => {
            //     // this.$swal.fire({
            //     //     title: 'Sucesso!',
            //     //     text: 'Anexos cadastrados com sucesso!',
            //     //     icon: 'success'
            //     // })
            // }).catch(error => {
            //     console.log(error)
            //     this.$swal.fire({
            //         title: 'Oops!',
            //         text: 'Falha ao cadastrar anexos, tente novamente!',
            //         icon: 'error'
            //     })
            // })
        }
    }
}
</script>
<style>
.custom-file-input:lang(en)~.custom-file-label::after {
    /* content: 'Escolher Arquivos'; */
}
  
</style>